import angular from 'angular'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ApolloProvider } from '@apollo/client'

import { getFeatures } from '~/featureFlags'

const newTemplateId = 'react-RevisionHistoryLocking'

const Link = (reduxStore) => (scope, el) => {
  const rootEl = el[0]

  scope.$on('$destroy', () => ReactDOM.unmountComponentAtNode(rootEl))

  getFeatures().then((features) => {
    if (features.isEnabled('draftApiStateful')) {
      Promise.all([
        import(
          /* webpackChunkName: 'lock-manager' */ '~/reactapp/App/LockManager'
        ),
        import(/* webpackChunkName: 'graphql-client' */ '~/graphql/client'),
      ]).then((imports) => {
        const { LockManager } = imports[0]
        const { default: client } = imports[1]
        ReactDOM.render(
          <ApolloProvider client={client}>
            <Provider store={reduxStore}>
              <LockManager documentId={scope.vm.storyObj._id} />
            </Provider>
          </ApolloProvider>,
          rootEl
        )
      })
    }
  })
}

function Controller() {
  // Empty controller
}

function directive(reduxStore) {
  return {
    replace: true,
    restrict: 'E',
    controllerAs: 'vm',
    bindToController: true,
    template: `<div id="${newTemplateId}"/>`,
    scope: {
      storyObj: '<',
    },
    controller: Controller,
    link: Link(reduxStore),
  }
}

export default angular
  .module('ellipsis.revisionHistoryLocking', [])
  .directive('revisionHistoryLocking', ['$ngRedux', directive])
